import {initTrustbars} from "../../../default/global/js/trustbar";
import {getChildrenClassForNestedItems} from "../../../default/global/js/nav";
import {initActionClicks, initFormSubmitChanges, initFormSubmitClicks} from "../../../default/global/js/actionClick";
import {focusInputGroups} from "../../../default/global/js/checkInputGroups";
import {stickyHeader} from "../../../default/global/js/stickyheader";
import {triggerFavoritesBtns} from "../../../reusch_global/js/global/favorites";
import {initQuantitySpinners} from "../../../default/global/js/quantitySpinner";
import hoverintent from "../../../default/global/js/hoverintent";
import {initSlideshows} from "../../../reusch_global/js/global/slideshow";
import {openFullscreenGallery} from "../../../reusch_global/js/global/fullscreengallery";
import {stickyBox} from "../../../default/global/js/stickyBox.js";
import {buildMobileMenu, hideMobileMenu, showMobileMenu} from "./mobilemenu";
import {slides} from "./slides";
import {
    excludeModal,
    triggerConfirmModalLink,
    triggerModal,
    triggerOpenLinkInModal,
    triggerOpenTextInModal
} from "../../../default/global/js/modal";
import {triggerBasketBtns, triggerUpdateBasketView} from "./basket";
import {initToggleSlide} from "../../../default/global/js/toggle";
import {initItemlistSlider} from "./itemListSlider";
import {setSrcVideos} from "../../../default/global/js/video";
import {initScrollbars} from "../../../default/global/js/scrollbar";
import {isTouchDevice} from "../../../default/global/js/touchDevice";
import {
    hideAllCustomSelect,
    hideCustomSelect,
    initCustomSelects,
    updateCustomSelectRangeFilterAction
} from "../../../reusch_global/js/global/customSelect";
import {initJumpmarks} from "../../../default/global/js/jumpmark";
import {initSearchItems} from "../../../default/global/js/searchItems";
import {trimInputValues} from "../../../default/global/js/formValidator";
import {addLoadingClassAfterSubmit} from "./utilities/updateClasses";
import {initPasswordFields} from "../../../default/global/js/password";
import {lottieLoader} from "../../../default/global/js/lottieLoader";
import {initSlidecontents} from "../../../default/global/js/slidecontent";
import {initFlashmessages} from "../../../default/global/js/flashmessages";
import {addTableWrapper} from "../../../default/global/js/tableWrapper";
import {initPhoneCountryFields} from "../../../default/global/js/phoneCountryField";
import {initInputBody} from "../../../reusch_global/js/inputfile";
import initDcOrder from "../../../default/global/js/dcorder";
import {initShowMoreRatings} from "../../../default/global/js/rating";
import {initImageGallery} from "../../../default/global/js/imageGallery";
import {initInputMaskDate} from "../../../default/global/js/inputMaskDate";
import {initRecaptchaForms} from "./recaptchaForm";
import {initAjaxCollectionFilter} from "../../../default/global/js/ajaxCollectionFilter";
import {initDatepicker} from "../../../default/global/js/datepicker";
import {initContentTabs} from "../../../default/global/js/contentTabs";
import {initHistorySlider} from "../../../default/global/js/history";
import {initAjaxFormApi} from "../../../default/global/js/ajaxFormApi";
import {initScrollActivate} from "../../../default/global/js/scrollactivate";
import {initRangeslider} from "../../../default/global/js/rangeSlider";
import {initFlyout} from "../../../default/global/js/flyoutMenu";
import {initHighlightEditors} from "../../../default/global/ts/highlightEditor";
import {maxHeightContent} from "../../../default/global/js/maxHeightContent";
import {global} from "../../../reusch_global/js/global";
import {initScrollableNavigation} from '../../../reusch_global/js/global/scrollableCategoryList';
import {closeFilters, reuschFilter} from "../../../reusch_global/js/custom/filter";
import {customFunctions} from "./custom";
import {initHighlightPicture} from "../../../default/global/js/highlightPicture";
import {videoLazy} from "../../../reusch_global/js/global/videoLazy";
import {decodedLinks} from "../../../reusch_global/js/custom/decodedLinks";
import {initNewsletter} from "../../../reusch_global/js/custom/newsletter";
import {initHeaderScroll} from "../../../reusch_global/js/custom/headerScroll";

function initMegaMenuKeyboardNav() {
    const mainNav = document.querySelector('.js-mainNavigation');
    if (!mainNav) return;

    const topLevelItems = Array.from(mainNav.querySelectorAll(':scope > ul > li.level_1'));

    topLevelItems.forEach((li) => {
        const topLink = li.querySelector(':scope > a');
        const megaMenu = li.querySelector('.megaMenu');

        if (!topLink) return;

        // Set initial aria-expanded if item has a megaMenu
        if (megaMenu) {
            topLink.setAttribute('aria-expanded', 'false');
            topLink.setAttribute('aria-haspopup', 'true');
        }

        // Open megaMenu when top-level link receives keyboard focus
        topLink.addEventListener('focus', () => {
            if (megaMenu) {
                li.classList.add('hoverintent');
                topLink.setAttribute('aria-expanded', 'true');
            }
        });

        // Escape on top-level link closes megaMenu
        topLink.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && li.classList.contains('hoverintent')) {
                li.classList.remove('hoverintent');
                topLink.setAttribute('aria-expanded', 'false');
            }
        });

        // Close megaMenu when focus leaves the entire li element
        li.addEventListener('focusout', (e) => {
            if (!li.contains(e.relatedTarget)) {
                li.classList.remove('hoverintent');
                if (megaMenu) topLink.setAttribute('aria-expanded', 'false');
            }
        });

        // Escape inside megaMenu closes it and returns focus to top-level link
        if (megaMenu) {
            megaMenu.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    li.classList.remove('hoverintent');
                    topLink.setAttribute('aria-expanded', 'false');
                    topLink.focus();
                }
            });
        }
    });
}

window.addEventListener("load", (event) => {
    const mobileMenu = document.querySelector('.mobileMenu');
    const mobileMenuToggle = document.getElementById("js-toggleNavigation");
    const overlay = document.getElementById("overlay");
    const IsTouchDevice = isTouchDevice();
    const stickyHeaderArea = document.querySelector('.headerMain');

    let breakPointSM = 1024;
    let sendFavoriteByJS = false;
    let sendItemToBasketByJS = false;
    let updateBasketByJS = false;

    if (typeof GLOBALS!== "undefined") {
        breakPointSM = GLOBALS.gridBreakpoints.sm;
        sendFavoriteByJS = GLOBALS.sendFavoriteByJS;
        sendItemToBasketByJS = GLOBALS.sendItemToBasketByJS;
        updateBasketByJS = GLOBALS.updateBasketByJS;
    }

    if (mobileMenu && mobileMenuToggle && overlay) {
        const mobileMenuClose = mobileMenu.querySelector(".mobileMenu__close");

        buildMobileMenu(mobileMenu);

        mobileMenuToggle.addEventListener("click", function () {
            showMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });

        mobileMenuClose.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });

        overlay.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);

            let showFilterBtn = document.querySelector("#showHideFilters");
            let filterBox = document.querySelector(".filterWrapper");
            if(showFilterBtn && filterBox) {
                closeFilters(showFilterBtn,filterBox);
            }
        });

        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape" && document.body.classList.contains("is-mobilemenuopen")) {
                hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            }
        });
    }

    initTrustbars();

    reuschFilter();

    initActionClicks();

    initFormSubmitClicks();

    initFormSubmitChanges();

    trimInputValues();

    focusInputGroups();

    initInputBody();

    initPhoneCountryFields();

    initHeaderScroll();

    if (window.outerWidth < breakPointSM) {
        for (let parent of document.querySelectorAll('.navgroup > ul > li')) {
            getChildrenClassForNestedItems(parent);
        }
    }

    if (sendFavoriteByJS) {
        triggerFavoritesBtns();
    }

    if (sendItemToBasketByJS) {
        triggerBasketBtns();
    }

    if (updateBasketByJS) {
        triggerUpdateBasketView();
    }

    triggerModal();
    excludeModal();
    triggerOpenLinkInModal();
    triggerConfirmModalLink();
    triggerOpenTextInModal();

    initQuantitySpinners();

    initToggleSlide();

    if (!IsTouchDevice) {
        for (let el of document.querySelectorAll('.itembox,.iconbarItem')) {
            hoverintent(el);
        }
    }
    for (let el of document.querySelectorAll('.js-mainNavigation li')) {
        hoverintent(el, 100);
    }

    initMegaMenuKeyboardNav();

    //setSrcVideos();

    initSlideshows();

    //initImageGallery();

    initScrollbars();

    initSlidecontents();

    initItemlistSlider();

    initCustomSelects();

    initHighlightPicture();

    initRangeslider(document,function (e){
        if(e.slider.closest(".js-customSelect")){
            updateCustomSelectRangeFilterAction(e.slider.closest(".js-customSelect"),e.value);
        }
    });

    // Tooltip, when necessary
    // import {Tooltip} from "../../../default/global/js/tooltip-custom";

    //var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
    //var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    //    return new Tooltip(tooltipTriggerEl);
    //});

    initSearchItems(document.querySelectorAll('.js-searchInput'));

    initFlashmessages();

    let offsetTopJumpmarks = 0;
    if (stickyHeaderArea) {
        offsetTopJumpmarks = stickyHeaderArea.clientHeight;
    }

    if (typeof GLOBALS!== "undefined") {
        if(GLOBALS.offsetTopJumpmarks){
            offsetTopJumpmarks += GLOBALS.offsetTopJumpmarks;
        }
    }

    initJumpmarks(offsetTopJumpmarks);

    for (let item of document.querySelectorAll(".js-openGallery")) {
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item);
        });
    }

    let offsetTopStickyBox = 30;
    if (stickyHeaderArea) {
        offsetTopStickyBox += stickyHeaderArea.clientHeight + 80;
    }

    for (let pinBox of document.querySelectorAll(".js-stickyBox")) {
        stickyBox(pinBox, {
            offsetTop: offsetTopStickyBox
        });
    }
    lottieLoader();

    addLoadingClassAfterSubmit();
    initPasswordFields();

    addTableWrapper();

    initDcOrder();

    initShowMoreRatings();

    initInputMaskDate();

    initRecaptchaForms();

    initAjaxCollectionFilter();

    initDatepicker();

    initHistorySlider();

    initContentTabs();

    initFlyout();

    initAjaxFormApi();

    initScrollActivate();

    initHighlightEditors();

    maxHeightContent();

    global();

    initScrollableNavigation();

    slides();

    customFunctions();


    sizechartTabs();

    videoLazy();

    decodedLinks();

    initNewsletter();

    window.main = {
        hideAllCustomSelect: function (){
            hideAllCustomSelect();
        },
        hideCustomSelect: function (select){
            hideCustomSelect(select);
        }
    }

    let mobileSearch = document.querySelector(".mobileSearch");
    if(mobileSearch) {
        mobileSearch.addEventListener("click", function () {
            if(mobileSearch.classList.contains("mobileSearch--active")){
                mobileSearch.classList.remove("mobileSearch--active");
            } else {
                mobileSearch.classList.add("mobileSearch--active");
            }
        });

        let headerSearch = document.querySelector(".headerSearch");
        document.addEventListener('click', event => {
            if (!headerSearch.contains(event.target)){
                mobileSearch.classList.remove("mobileSearch--active");
            }
        });
    }

    let langModal = document.getElementById("languageSwitchModal");
    let langButton = document.querySelector(".languageSwitchButton");
    if(langModal && langModal.dataset.showModal && langButton) {
        langButton.click();
    }

    initItemboxAttributesDragScroll();

});

function sizechartTabs() {
    let sizeCharts = document.querySelectorAll(".sizeChart");
    for(let sizeChartWrap of sizeCharts) {
        let sizechartTabs = sizeChartWrap.querySelectorAll(".sizeChartTab");
        let sizecartContents = sizeChartWrap.querySelectorAll(".sizeChartContent");
        if(sizechartTabs && sizecartContents) {
            for(let tab of sizechartTabs) {
                tab.addEventListener("click", function () {
                    for(let cTab of sizechartTabs) {
                        cTab.classList.remove("activeTab");
                    }
                    this.classList.add("activeTab");
                    let tabValue = this.dataset.tab;

                    for(let sizeChart of sizecartContents) {
                        let contentValues = sizeChart.dataset.content.split(",");
                        if(contentValues.includes(tabValue)) {
                            sizeChart.classList.add("activeContent");
                        } else {
                            sizeChart.classList.remove("activeContent");
                        }
                    }
                });
            }
        }
    }
}

function initItemboxAttributesDragScroll() {
    for (let el of document.querySelectorAll('.itemboxAttributes')) {
        let isDown = false;
        let startX;
        let scrollLeft;
        let velX = 0;
        let lastX = 0;
        let rafId;

        const momentum = () => {
            if (Math.abs(velX) < 0.5) return;
            el.scrollLeft += velX;
            velX *= 0.92;
            rafId = requestAnimationFrame(momentum);
        };

        let didDrag = false;

        el.addEventListener('mousedown', (e) => {
            cancelAnimationFrame(rafId);
            isDown = true;
            didDrag = false;
            velX = 0;
            startX = e.clientX;
            lastX = e.clientX;
            scrollLeft = el.scrollLeft;
            el.style.cursor = 'grabbing';
            el.style.userSelect = 'none';
            e.preventDefault();
        });

        document.addEventListener('mouseup', () => {
            if (!isDown) return;
            isDown = false;
            el.style.cursor = '';
            el.style.userSelect = '';
            rafId = requestAnimationFrame(momentum);
        });

        document.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            if (Math.abs(e.clientX - startX) > 4) didDrag = true;
            velX = lastX - e.clientX;
            lastX = e.clientX;
            el.scrollLeft = scrollLeft + (startX - e.clientX);
        });

        document.addEventListener('click', (e) => {
            if (didDrag) {
                e.stopPropagation();
                e.preventDefault();
                didDrag = false;
            }
        }, true);
    }
}